import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { apiRoutes } from 'src/app/constants/apiRoutes';
import { ApiCallMethodsService } from 'src/app/shared/services/api-call-methods.service';
import { LoaderService } from 'src/app/shared/services/loader-service/loader-service.service';
import { AuthService } from '../../services/auth.service';
import Cookies from 'js-cookie';

@Component({
  selector: 'app-non-ui-auth',
  templateUrl: './non-ui-auth.component.html',
  styleUrls: ['./non-ui-auth.component.scss']
})
export class NonUiAuthComponent {

  queryParams: any = null;

  constructor(private loaderService: LoaderService, private activatedRoute: ActivatedRoute, private apiCallMethodsService: ApiCallMethodsService,
    private authService: AuthService, private router: Router
  ) {

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.loaderService.startLoader();
      let savedCSRF = localStorage.getItem('CSRF');
      console.log(params);
      this.queryParams = params;
      // Invite flow: state = "invite_<token>" — skip CSRF validation.
      // The invite token itself is the trust proof; backend re-validates it during token exchange.
      const isInviteFlow = params?.state?.startsWith('invite_');

      if (isInviteFlow || params?.state == savedCSRF) {
        this.checkToken();
      }
      else {
        console.log('CRSF DOES NOT MATCH!');
      }

    })

  }

  checkToken() {

    let apiUrl = `auth/token`;

    const baseUrl = window.location.origin;

    let sessionCookie = Cookies.get("sso_session");
    if (sessionCookie) {
      localStorage.setItem("sso_session_id", sessionCookie);
    }

    let payload = {
      code: this.queryParams.code,
      client_id: 'cb-sales',
      redirect_uri: baseUrl + '/auth/callback',
      sessionId: sessionCookie
    }

    this.apiCallMethodsService.post(apiUrl, payload).subscribe((response: any) => {
      this.loaderService.stopLoader();
      console.log(response);

      if (response.success) {

        let session = {
          token: {
            token: response.accessToken,
            refreshToken: response.refreshToken,
            expiresIn: response.expiresIn,
            tokenType: response.tokenType
          },
          user: response.user
        }

        console.log(session);

        this.authService.removeId();
        this.authService.setToken(session);
        this.router.navigate(['/select-company']);
      }

    }, (error: any) => {
      this.loaderService.stopLoader();
      console.log(error);
    });

  }

}
